<template>
  <div class="rts-dashboard">
    <!-- 顶部栏 -->
    <header class="dashboard-header relative">
      <div class="header-left">
        <h1 class="header-logo">RTS</h1>
        <!-- 手机端一级目录折叠入口 -->
        <el-dropdown class="mobile-menu" trigger="click" @command="onMenuSelect">
          <el-button type="text" icon="el-icon-menu" class="mobile-menu-btn"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="userForm" :class="{ 'is-active-item': activeMenu === 'userForm' }">
              用户表单
            </el-dropdown-item>
            <el-dropdown-item command="activity" :class="{ 'is-active-item': activeMenu === 'activity' }">
              活动管理
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <span class="header-divider">|</span> -->
        <!-- <span class="header-title">留资实时统计后台</span> -->
      </div>
      <!-- 一级目录 -->
      <el-menu
        class="top-menu"
        mode="horizontal"
        :default-active="activeMenu"
        background-color="#1a1a2e"
        text-color="#c9c9d6"
        active-text-color="#ffffff"
        @select="onMenuSelect"
      >
        <el-menu-item index="userForm">用户表单</el-menu-item>
        <el-menu-item index="activity">活动管理</el-menu-item>
      </el-menu>
      <div class="header-right">
        <el-select
          v-model="brand"
          size="small"
          class="brand-select"
          @change="onBrandChange"
          :disabled="role !== 'super'"
        >
          <el-option v-for="opt in brandOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
        </el-select>
        <!-- <el-tag size="small" :type="pollingActive ? 'success' : 'info'" class="status-tag">
          <span class="status-dot" :class="{ active: pollingActive }"></span>
          {{ pollingActive ? '自动刷新' : '已暂停' }}
        </el-tag> -->
        <span class="absolute bottom-[-20px] right-[20px] text-[#000] text-[12px]">上次更新: {{ lastUpdateTime }}</span>
        <el-button size="small" icon="el-icon-refresh" circle @click="manualRefresh" :loading="refreshing"></el-button>
        <span class="header-phone">{{ phone }}</span>
        <el-button type="text" class="logout-btn" @click="handleLogout">退出</el-button>
      </div>
    </header>

    <!-- 二级 Tab 切换 -->
    <div class="dashboard-tabs">
      <el-tabs v-if="activeMenu === 'userForm'" v-model="activeTab" @tab-click="onTabClick">
        <el-tab-pane label="留资记录" name="leads">
          <lead-table ref="leadTableRef" :auto-refresh="pollingActive" :brand="brand"></lead-table>
        </el-tab-pane>
        <el-tab-pane label="数据统计" name="statistics">
          <statistics-panel ref="statsPanelRef" :auto-refresh="pollingActive" :brand="brand"></statistics-panel>
        </el-tab-pane>
      </el-tabs>
      <el-tabs v-else v-model="activeTab" @tab-click="onTabClick">
        <el-tab-pane label="活动列表" name="activity">
          <activity-manage ref="activityRef" :brand="brand" @activity-changed="onActivityChanged"></activity-manage>
        </el-tab-pane>
        <el-tab-pane label="活动配置" name="currentUrl">
          <current-url-manage ref="currentUrlRef" :brand="brand"></current-url-manage>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import LeadTable from '@/components/admin/LeadTable.vue'
import StatisticsPanel from '@/components/admin/StatisticsPanel.vue'
import ActivityManage from '@/components/admin/ActivityManage.vue'
import CurrentUrlManage from '@/components/admin/CurrentUrlManage.vue'
import Vue from 'vue'

export default {
  name: 'RtsDashboard',
  components: {
    LeadTable,
    StatisticsPanel,
    ActivityManage,
    CurrentUrlManage,
  },
  data() {
    return {
      activeMenu: 'userForm',
      activeTab: 'leads',
      role: sessionStorage.getItem('rts_role') || 'super',
      brand:
        sessionStorage.getItem('rts_role') === 'super'
          ? sessionStorage.getItem('rts_saved_brand') || 'icaur'
          : sessionStorage.getItem('rts_role') || 'icaur',
      pollingActive: true,
      refreshing: false,
      lastUpdateTime: this.formatTime(new Date()),
      pollingTimer: null,
      phone: '',
    }
  },
  computed: {
    brandOptions() {
      const all = [
        { label: 'HONGQI', value: 'hongqi' },
        { label: 'ZEEKR', value: 'zeekr' },
        { label: 'ICAUR', value: 'icaur' },
      ]
      if (this.role === 'super') return all
      return all.filter((opt) => opt.value === this.role)
    },
  },
  created() {
    this.phone = sessionStorage.getItem('rts_phone') || ''
    const token = sessionStorage.getItem('rts_token')
    if (!token) {
      this.$router.replace({ path: '/RTS/KLM' })
      return
    }
    // 超过12小时自动退出
    const tokenTime = parseInt(token, 10)
    if (Date.now() - tokenTime > 12 * 60 * 60 * 1000) {
      sessionStorage.removeItem('rts_token')
      sessionStorage.removeItem('rts_saved_brand')
      this.$router.replace({ path: '/RTS/KLM' }).catch(() => {})
      return
    }
    this.wrapMessage()
    this.startPolling()
  },
  beforeDestroy() {
    this.stopPolling()
    // 恢复全局 $message
    if (this._originalProtoMessage) {
      Vue.prototype.$message = this._originalProtoMessage
    }
  },
  methods: {
    wrapMessage() {
      const msg = this.$message
      const wrapper = (options) => {
        const opts = typeof options === 'string' ? { message: options } : { ...options }
        if (!opts.offset) opts.offset = 70
        return msg(opts)
      }
      ;['success', 'warning', 'info', 'error'].forEach((type) => {
        wrapper[type] = (options) => {
          const opts = typeof options === 'string' ? { message: options } : { ...options }
          opts.type = type
          if (!opts.offset) opts.offset = 70
          return msg(opts)
        }
      })
      wrapper.close = msg.close
      wrapper.closeAll = msg.closeAll
      this.$message = wrapper
      // 同时包装全局 Vue.prototype.$message，拦截 axios 拦截器中的调用
      this._originalProtoMessage = Vue.prototype.$message
      Vue.prototype.$message = wrapper
    },
    startPolling() {
      this.pollingActive = true
      this.pollingTimer = setInterval(() => {
        this.refreshCurrentTab()
      }, 120000)
      // 2分钟
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    refreshCurrentTab() {
      if (this.activeTab === 'leads' && this.$refs.leadTableRef) {
        this.$refs.leadTableRef.fetchData()
      } else if (this.activeTab === 'statistics' && this.$refs.statsPanelRef) {
        this.$refs.statsPanelRef.fetchData()
      } else if (this.activeTab === 'activity' && this.$refs.activityRef) {
        this.$refs.activityRef.fetchData()
      } else if (this.activeTab === 'currentUrl' && this.$refs.currentUrlRef) {
        this.$refs.currentUrlRef.fetchData()
      }
      this.lastUpdateTime = this.formatTime(new Date())
    },
    async manualRefresh() {
      this.refreshing = true
      try {
        this.refreshCurrentTab()
        this.$message({ message: '刷新成功', type: 'success', duration: 500 })
      } finally {
        this.refreshing = false
      }
    },
    onBrandChange() {
      if (this.role === 'super') {
        sessionStorage.setItem('rts_saved_brand', this.brand)
      }
      this.$nextTick(() => {
        if (this.activeTab === 'leads' && this.$refs.leadTableRef) {
          this.$refs.leadTableRef.fetchData()
        } else if (this.activeTab === 'statistics' && this.$refs.statsPanelRef) {
          this.$refs.statsPanelRef.fetchData()
        } else if (this.activeTab === 'activity' && this.$refs.activityRef) {
          this.$refs.activityRef.fetchData()
        } else if (this.activeTab === 'currentUrl' && this.$refs.currentUrlRef) {
          this.$refs.currentUrlRef.fetchData()
        }
      })
    },
    onTabClick() {
      this.loadActiveTab()
    },
    onMenuSelect(index) {
      this.activeMenu = index
      this.activeTab = index === 'userForm' ? 'leads' : 'activity'
      this.loadActiveTab()
    },
    loadActiveTab() {
      this.$nextTick(() => {
        if (this.activeTab === 'leads' && this.$refs.leadTableRef) {
          this.$refs.leadTableRef.fetchActivities()
          this.$refs.leadTableRef.fetchDefaultActivity().then(() => this.$refs.leadTableRef.fetchData())
        } else if (this.activeTab === 'statistics' && this.$refs.statsPanelRef) {
          this.$refs.statsPanelRef.fetchActivities()
          this.$refs.statsPanelRef.fetchDefaultActivity().then(() => this.$refs.statsPanelRef.fetchData())
        } else if (this.activeTab === 'activity' && this.$refs.activityRef) {
          this.$refs.activityRef.fetchData()
        } else if (this.activeTab === 'currentUrl' && this.$refs.currentUrlRef) {
          this.$refs.currentUrlRef.fetchData()
          this.$refs.currentUrlRef.fetchActivities()
        }
      })
    },
    onActivityChanged() {
      // 活动管理增删改后，刷新其他组件的活动下拉
      this.$nextTick(() => {
        if (this.$refs.leadTableRef) {
          this.$refs.leadTableRef.fetchActivities()
        }
        if (this.$refs.statsPanelRef) {
          this.$refs.statsPanelRef.fetchActivities()
        }
        if (this.$refs.currentUrlRef) {
          this.$refs.currentUrlRef.fetchActivities()
        }
      })
    },
    formatTime(date) {
      const h = String(date.getHours()).padStart(2, '0')
      const m = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${h}:${m}:${s}`
    },
    handleLogout() {
      sessionStorage.removeItem('rts_token')
      sessionStorage.removeItem('rts_role')
      sessionStorage.removeItem('rts_saved_brand')
      // sessionStorage.removeItem('rts_phone')
      this.stopPolling()
      this.$router.replace({ path: '/RTS/KLM' }).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.rts-dashboard {
  min-height: 100vh;
  background: #f0f2f5;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 14px;
  background: #1a1a2e;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  .top-menu {
    flex: 1;
    display: flex;
    justify-content: center;
    border-bottom: none;

    ::v-deep .el-menu-item {
      height: 56px;
      line-height: 56px;
      font-size: 15px;
      font-weight: 600;
      border-bottom: 3px solid transparent !important;
    }

    ::v-deep .el-menu-item.is-active {
      border-bottom: 3px solid #fff !important;
    }
  }

  .mobile-menu {
    display: none;

    .mobile-menu-btn {
      color: #fff;
      font-size: 20px;
      padding: 0;
    }
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;

    .header-logo {
      font-size: 22px;
      font-weight: 800;
      letter-spacing: 2px;
      margin: 0;
      color: #fff;
    }

    .header-divider {
      color: #555;
      font-size: 18px;
    }

    .header-title {
      font-size: 14px;
      color: #ccc;
      letter-spacing: 1px;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 12px;

    .brand-select {
      width: 110px;
    }

    .status-tag {
      .status-dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #909399;
        margin-right: 4px;

        &.active {
          background: #67c23a;
          animation: pulse 1.5s infinite;
        }
      }
    }

    .header-phone {
      font-size: 13px;
      color: #ccc;
    }

    .logout-btn {
      color: #f56c6c;
      padding: 0;
      font-size: 13px;
    }
  }
}

.dashboard-tabs {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 12px;

  ::v-deep .el-tabs__header {
    margin-bottom: 16px;
  }

  ::v-deep .el-tabs__item {
    font-size: 15px;
    font-weight: 500;
    height: 44px;
    line-height: 44px;
  }

  ::v-deep .el-tabs__active-bar {
    height: 3px;
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

/* 下拉选中的一级目录高亮 */
.is-active-item {
  color: #409eff !important;
  font-weight: 700;
}

/* 手机端：折叠一级目录 */
@media (max-width: 768px) {
  .dashboard-header {
    .top-menu {
      display: none;
    }

    .mobile-menu {
      display: inline-block;
    }

    .header-right {
      gap: 8px;
    }
  }
}
</style>
